import styles from './ConfirmModal.module.css';

type ConfirmModalProps = {
  text: string;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Confirm dialog content — rendered inside the shared Modal primitive.
 * Does not own the overlay; ConfirmProvider wraps it in <Modal>.
 */
export const ConfirmModal = ({
  text,
  onConfirm,
  onCancel,
}: ConfirmModalProps) => (
  <div className={styles.content}>
    <p className={styles.text}>{text}</p>

    <div className={styles.buttons}>
      <button type="button" className={styles.yes} onClick={onConfirm}>
        Так
      </button>
      <button type="button" className={styles.no} onClick={onCancel}>
        Ні
      </button>
    </div>
  </div>
);
